export default {"src":"/_next/static/media/rdn.1bd4d5a1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};